<template>
  <Transition name="fade">
    <aside
      v-if="component"
      class="w-full h-full fixed top-0 left-0 bg-black/70 z-50 cursor-pointer"
      @click.stop="closeModal"
    >
      <component :is="component" />
    </aside>
  </Transition>
</template>

<script lang="ts">
import { computed } from 'vue'

import CarouselModal from '@/components/modal/blocks/CarouselModal.vue'
import BookingPopup from '@/components/modal/BookingPopup.vue'
import { useScrollLock } from '@/composables/useScrollLock.ts'
import { useModalStore } from '@/stores/modal.ts'

export default {
  name: 'SiteModal',
  setup() {
    const store = useModalStore()

    const component = computed(() => {
      switch (store.type) {
        case store.TYPES.BOOKING:
          return BookingPopup
        case store.TYPES.CAROUSEL:
          return CarouselModal
        default:
          return null
      }
    })

    const open = computed(() => store.type !== null)

    useScrollLock(open)

    return {
      closeModal: store.close,
      component,
    }
  },
}
</script>
